import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_QUARTEL_URL} from '../../connection.data';
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { Quartel} from '../_models/quartel.model';

@Injectable()
export class QuartelService{
    constructor(private http: HttpClient){

    }

    getAll():Observable<Quartel[]>{
        const url = `${API_QUARTEL_URL}/all`;
        return this.http.get<{rows: any, status: string}>(url).pipe(
            map((response)=>{
                return response.rows;
            })
        )
    }

    getPage(queryParams: QueryParamsModel):Observable<QueryResultsModel>{
        const url = `${API_QUARTEL_URL}/page`;
        return this.http.post<QueryResultsModel>(url, queryParams)
    }

    add(quartel:Quartel):Observable<number>{
        return this.http.post<any>(API_QUARTEL_URL, quartel).pipe(
            map((response)=> response.id)
        );
    }

    edit(quartel:Quartel):Observable<string>{
        return this.http.put<any>(`${API_QUARTEL_URL}/${quartel.id}`, quartel).pipe(
            map((response)=>response.status)
        );
    }

    delete(quartel:Quartel):Observable<string>{
        return this.http.delete<any>(`${API_QUARTEL_URL}/${quartel.id}`).pipe(
            map((response)=>response.status)
        );
    }
}